// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a1b8ab10","455":"67270cc9","977":"9a24b941"}[chunkId] + ".chunk.js";
};